import { useEffect, useRef, useState } from "react";
import { Send, Gift, X } from "lucide-react";
import { api } from "@/lib/api";
import { GiftPicker } from "@/components/GiftPicker";

export const ChatBox = ({ cs, me, peer, chatCoins, gifts = [], onClose }) => {
  const [text, setText] = useState("");
  const [giftOpen, setGiftOpen] = useState(false);
  const endRef = useRef(null);
  const msgs = cs.chats[peer.id] || [];

  useEffect(() => { api.get(`/chat/${peer.id}`).then((r) => cs.loadChat(peer.id, r.data)).catch(() => null); }, [peer.id]); // eslint-disable-line
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs.length]);

  const submit = (e) => {
    e.preventDefault();
    const t = text.trim().slice(0, 50);
    if (!t) return;
    cs.sendChat(peer.id, t);
    setText("");
  };

  return (
    <div data-testid="chat-box" className="card rounded-3xl flex flex-col h-[70vh] max-h-[560px] overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-[var(--line)]">
        <div>
          <p className="font-bold">{peer.name}</p>
          <p className="text-[11px] text-[var(--muted-text)]">{me.role === "customer" ? <>ഒരു മെസ്സേജ് = <span className="font-num font-bold text-[var(--accent-c)]">₹{(chatCoins || 12) / 6}</span></> : "20 അക്ഷരങ്ങൾ വരെ"}</p>
        </div>
        {onClose && <button data-testid="chat-close-button" onClick={onClose} className="btn-ghost w-8 h-8 rounded-lg inline-flex items-center justify-center"><X size={14} /></button>}
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-3 space-y-2" data-testid="chat-messages">
        {msgs.length === 0 && <p className="text-xs text-[var(--muted-text)] text-center mt-10">സംഭാഷണം ആരംഭിക്കൂ</p>}
        {msgs.map((m) => (
          <div key={m.id} className={`flex ${m.from_id === me.id ? "justify-end" : "justify-start"}`}>
            <span className={`max-w-[75%] rounded-2xl px-3.5 py-2 text-sm ${m.from_id === me.id ? "bg-[var(--accent-c)] text-[var(--accent-fg)] rounded-br-sm" : "bg-[var(--charcoal-2)] rounded-bl-sm"}`}>{m.text}</span>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      {giftOpen && <div className="px-3 pb-2"><GiftPicker gifts={gifts} onSend={(id) => { cs.sendGift(peer.id, id); setGiftOpen(false); }} /></div>}
      <form onSubmit={submit} className="flex items-center gap-2 p-3 border-t border-[var(--line)]">
        {me.role === "customer" && <button type="button" data-testid="chat-gift-button" onClick={() => setGiftOpen((v) => !v)} className="btn-ghost w-10 h-10 rounded-xl inline-flex items-center justify-center shrink-0"><Gift size={16} /></button>}
        <div className="relative flex-1">
          <input data-testid="chat-input" value={text} maxLength={50} onChange={(e) => setText(e.target.value.slice(0, 50))} placeholder="50 അക്ഷരങ്ങൾ വരെ..." className="w-full h-10 rounded-xl bg-[var(--wine)] border border-[var(--line)] px-3 pr-12 text-sm focus:outline-none focus:ring-2 focus:ring-[var(--accent-c)]" />
          <span data-testid="chat-char-count" className={`absolute right-3 top-1/2 -translate-y-1/2 font-num text-[10px] ${text.length >= 50 ? "text-[var(--crimson)]" : "text-[var(--muted-text)]"}`}>{text.length}/50</span>
        </div>
        <button data-testid="chat-send-button" disabled={!text.trim()} className="btn-accent w-10 h-10 rounded-xl inline-flex items-center justify-center shrink-0 disabled:opacity-40"><Send size={16} /></button>
      </form>
    </div>
  );
};
